import axios from "axios";
import { config } from "@/config";

const browserStorageNamespace = "YNBTrade";

// function redirectIfBadToken(error) {
//   const { status, data } = error.response;
//   if (status === 401) {
//     // Checking if status is 401 should be enough to determine if we need to redirect to login,
//     // but just in case, we check the error message to ensure we're only redirecting when token
//     // is invalid or expired.
//     const tokenErrors = [
//       "Authentication token invalid or expired.",
//       "Token Expired.", // Deprecated
//       "Invalid Token." // Deprecated
//     ];
//     if (tokenErrors.indexOf(data.description) > -1) {
//       import("@/router").then(router => {
//         browserStorageRemoveItem("token");
//         router.default.push({ name: "auth.logout" });
//       });
//     }
//   }
// }

export function browserStorageSetItem(key, val) {
  if (sessionStorage) {
    sessionStorage.setItem(`${browserStorageNamespace}-${key}`, val);
  }
  localStorage.setItem(`${browserStorageNamespace}-${key}`, val);
}

export function browserStorageGetItem(key) {
  let item = null;
  if (sessionStorage) {
    item = sessionStorage.getItem(`${browserStorageNamespace}-${key}`);
  }
  if (!item) {
    item = localStorage.getItem(`${browserStorageNamespace}-${key}`);
  }
  return item;
}

export function browserStorageRemoveItem(key) {
  if (sessionStorage) {
    sessionStorage.removeItem(`${browserStorageNamespace}-${key}`);
  }
  return localStorage.removeItem(`${browserStorageNamespace}-${key}`);
}

export function lazyAxFactory(
  baseURL,
  options = { includeAuth: true, storageTokenKey: "token" }
) {
  const ax = axios.create({ baseURL });
  ax.interceptors.request.use(
    axConfig => {
      const { includeAuth } = options;
      if (includeAuth) {
        // eslint-disable-next-line
        axConfig.headers.Authorization = `Bearer ${config.backendToken}`;
      }
      return axConfig;
    },
    error => Promise.reject(error)
  );
  // ax.interceptors.response.use(
  //   response => response,
  //   error => {
  //     const token = browserStorageGetItem(options.storageTokenKey);
  //     if (token && error.response) {
  //       redirectIfBadToken(error);
  //     }
  //     return Promise.reject(error);
  //   }
  // );
  return ax;
}
